export default __webpack_public_path__ + "static/media/vr_img.a533533f.png";